import React, { Component } from 'react';
import PresentationSingleRecording from 'pages/PKCreation/PKCreationSteps/Audio/PresentationSingleRecording/Presentation';
import PresentationRecordingPerSlide from 'pages/PKCreation/PKCreationSteps/Audio/PresentationRecordingPerSlide/Presentation';
import PresentationVideoSingleRecording from 'pages/PKCreation/PKCreationSteps/Audio/PresentationVideoSingleRecording/Presentation';
//import PresentationVideoPerSlide from 'pages/PKCreation/PKCreationSteps/Audio/PresentationVideoPerSlide/Presentation';
import { user_access_token, user_access_level } from 'Api/Api';
import EmptyMessage from 'components/EmptyMessage/EmptyMessage';
import axios from 'axios';
import ActivityIndicator from "components/ActivityIndicator/ActivityIndicator";
import { withRouter, Link } from 'react-router-dom';
// Redirect,
// import sanitize from 'sanitize-filename';

// Links of Description section
import "../style.css";
// import { Category_list_Api, HeaderConfig, user_API, user_entity_uuid } from "Api/Api";
import { user_account_level, org_friendly_url, presentation_Creation_API, myHeaders_Auth_With_Cache_Control } from 'Api/Api'
// , myHeaders_Autorized, org_account_level
import { saveKey } from "utils/Helper";
// massageFriendlyUrl, , current_unix_stamp
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
// import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
// import MultiSelect from "components/MultiSelectSearch/MultiSelect";
// import Multisearch from "components/MultiSelectSearch/MultiSearch";
// import PKButton from 'components/Button/Button';
// import { slides_Creation_API } from 'Api/Api';
// import logo from "Assets/cloud-upload.png";
// import RUG from "react-upload-gallery";
import "react-upload-gallery/dist/style.css";
// Links of Audio
import mic from "Assets/mic.png";
import cloud from "Assets/cloud-upload.png";
import option from "Assets/Group 13.png";
import dark_option from "Assets/pk_OR_dark_transparent_3.png";
//import option1 from "Assets/option1.png"; why



import ReactTooltip from 'react-tooltip';

import silence_20s from "Assets/audio/silence_20s.mp3";
import silence_25s from "Assets/audio/silence_25s.mp3";
import silence_100s from "Assets/audio/silence_100s.mp3";
import silence_200s from "Assets/audio/silence_200s.mp3";
import silence_400s from "Assets/audio/silence_400s.mp3";

// Links of Presentation section
import { user_Status_Ver,user_Status } from 'Api/Api'
// Links of PK success page
//import PKSuccess from 'pages/PKList/PkList';
// import LegacyJSON from 'utils/LegacyArrays.json';
import { local_routes } from 'utils/Routes';

import UserContext from 'store/UserContext';

//import { isIOS } from "react-device-detect";
const isIOS = false; // iOS 14.3 and up should work - no warnings needed



let event_Name_Arr= [];
let my_Events = [];
let pkEvent = [];
let event_Picked;
//let slideImgPresentation=[];
let apiEventResArr=[]; // for event data from API
//let SlideTempArr = [];
//let SlideFinalPushTemp = [];
//let SlideArrData = []; // will hold slides from database
//let SlideDataPatch = [];
//let SlideImageArr = [];
//let SlideImageThumbnail = [];

//let slideCoverArr=[]; // for the actual dropdown data

//let promiseCheck=[];

class PresentationAudio extends Component {
    static contextType = UserContext;
    constructor(props) {
        super(props)
        this.state = {
            slides_array: [],
            presentation_info: {},
            
            silence_file: '',
            silent_flag: false,
            wrapup_time_ms: 0,
            slide_count: 20,
            slide_length: 20,
            presentation_uuid: props.presentation_uuid,
            touched: {},
            //isCreate: false,
            uploadedFileContents:[],
            pkOwnerCheck:true,
            // Tabs Code states
            step: 1,
            textarea: '',
            textareaError: '',
            //PKTitle: '',
            //FriendlyUrl: '',
            eventdropdown: '',
            // Description Links starts
            descriptionLoader: false,
            myEventsState: [],
            PKCreationPresentationId: null,
            pkFriendlyUrl: '',
            pkDescription: '',
            // pkEvent: '',
            pkEvent_name:'',
            myEventsDefault:'None',
            validated: false,
            showComponent: false,
            Categories: [],
            Category_names: [],
            loading: true,
            FriendlyUrlStatus: 0,
            cat_Arr: null,
            friendlyUrlCollision: true,
            pkTitleCollision: true,
            friendlyurl_title: '',
            apiCategoryRes:[],
            //apiCategories:[],
            apiEvents:[],
            btnDisableValidate:true,
             //Image section states
            //SlideImageCover:0,
            //slideCoverNum:0, // updated cover image index
            //slideBG: "black", // updated pad_color
            slide_cover_index_changed: false,
            slide_cover_index: 0, // starting cover image index (order_integer - 1)
            pad_color: 'black', // starting pad_color
            pad_color_changed: false,
            ImageUploadLoader: false,
            images: [],
            SlideNumber: 0,
            FriendlyUrlNumber: 1,
            //SlideCounter: 0,
            presentationId: '',
            savedImages: [], // on edit, this is the slides from the database before changes are done
            //apiImagesStack:[],
            imageValidator: false,
            ImgPublishBtn:false,
            // Audio section starts
            audioType: "",   
            pkAudio:'',
            pkAudioOrig:'',
            stored_Cat:[], 
            // createPkStatus:false
            allowed: true,
            audio_delay:0,
            language_abbreviation:'en-US',
            audioFileName:'',
            rugChangedCount: 0,
            slidesChanged: false
        };
        this.default_slide_length = 20;
        this.default_slide_count = 20;

        //this.usingMediaRecorder = typeof window.MediaRecorder !== 'undefined' ? true : false;
        this.usingMediaRecorder = true;
        console.log("usingMediaRecorder",this.usingMediaRecorder);
        
        this.workspace_base_url = "";
        if (org_friendly_url) {
          this.workspace_base_url = local_routes.workspace+"/"+org_friendly_url;
        }
        
    }

    // Audio section starts here
    startRecording = (audioType) => {
        this.setState({ audioType: audioType });
    }
    
    /*
    startRecording = () => {
        this.setState({ audioType: "record" })
    };
    
    startRecordingPerSlide = () => {
        this.setState({ audioType: "record_per_slide" })
    };
    
    startRecordingVideoPerSlide = () => {
        this.setState({ audioType: "record_video_per_slide" })
    };
    */
    
    
    uploadRecording = () => {
        this.setState({
            silent_flag: false,
            pkAudio: this.state.pkAudioOrig,
            audioType: "upload"
        })
    };
    
    uploadSilence = () => {
        let silence_file;
        let seconds_of_silence = this.state.slide_count * this.state.slide_length;
        if (seconds_of_silence === 20) {
            silence_file = silence_20s;    
        } else if (seconds_of_silence === 25) {
            silence_file = silence_25s;    
        } else if (seconds_of_silence === 100) {
            silence_file = silence_100s;
        } else if (seconds_of_silence === 200) {
            silence_file = silence_200s;
        } else if (seconds_of_silence === 400) {
            silence_file = silence_400s;    
        } else {
            // error! not supported
            return;
        }
        this.setState({
            //wrapup_time_ms: 0,
            //audio_delay: 0,
            silent_flag: true,
            pkAudio: silence_file,
            audioType: "upload"
        })
    };
    

    APICalls = async () => {
        try {
            let params = {
                sort_obj: {
                    order_integer: 'asc'
                },
                filter_obj: {
                    order_integer: {
                        gte: 1
                    }
                }
            }
            let [presentationRes,userUploadedSlidesRes] = await Promise.all([
                axios.get(`${presentation_Creation_API}/${this.props.presentation_uuid}`, myHeaders_Auth_With_Cache_Control),
                axios.get(`${presentation_Creation_API}/${this.props.presentation_uuid}/slides`, { params, ...myHeaders_Auth_With_Cache_Control }),
            ]);

            let storedCatTempArr=[];
            let tmp_presentation_cats_obj = {};
            let cover_image_url = "";
            //if (presentationRes.data) {
                let resData = presentationRes.data;
                // get simple audio file name
                let audioFileName = "";
                if (resData.audio_url) {
                    let tmp_array = resData.audio_url.split('/');
                    audioFileName = tmp_array[tmp_array.length-1];
                }

                let slide_count = this.default_slide_count;
                let slide_length = this.default_slide_length;
                if (resData.slide_count) {
                    slide_count = resData.slide_count;
                } else {
                    resData.slide_count = this.default_slide_count;
                }
                if (resData.slide_length) {
                    slide_length = resData.slide_length;
                } else {
                    resData.slide_length = this.default_slide_length;
                }
                let wrapup_time_ms = 0;
                if (resData.wrapup_time_ms) {
                    wrapup_time_ms = resData.wrapup_time_ms;
                }

                /*
                this.setState({
                    presentation_info: presentationRes.data,
                    wrapup_time_ms,
                    slide_count,
                    slide_length,
                    pkTitle: resData.entity_name,
                    pkFriendlyUrl: resData.friendly_url,
                    pkDescription: resData['description'],
                    //pkDescription: '',
                    PKCreationPresentationId: resData.entity_uuid,
                    pkAudio:resData.audio_url,
                    pkAudioOrig:resData.audio_url,
                    audioFileName,
                    audio_delay:resData.audio_delay,
                    language_abbreviation:resData.language_abbreviation,
                    //pad_color:resData.pad_color,
                    cover_image_url:resData.image_url,
                    slidesChanged: true
                })
                */
                let padCol=resData.pad_color;
                //console.log("API resData",resData);
                //console.log("API padCol",padCol);
                if (padCol) {
                    this.setState({ pad_color: padCol });
                }
                cover_image_url = presentationRes.data.image_url;
            //}
            //if (userUploadedSlidesRes.data) {
                let tempUserSlidesArr=[];
                let tmp_slide_cover_index = 0;
                userUploadedSlidesRes.data.forEach((item)=>{
                    tempUserSlidesArr.push({
                        source: item.image_url,
                        name: item.entity_name,
                        xref_data:item.xref_data.order_integer,
                        entity_uuid:item.entity_uuid
                    });
                    
                    if (cover_image_url && cover_image_url === item.image_url) {
                        tmp_slide_cover_index = item.xref_data.order_integer - 1;
                    }
                });
                /*
                this.setState({
                    savedImages:tempUserSlidesArr,
                    slide_cover_index:tmp_slide_cover_index,
                    slides_array: userUploadedSlidesRes.data || []
                });
                */
            //}
            this.setState({
              loading: false,
              presentation_info: presentationRes.data,
              wrapup_time_ms,
              slide_count,
              slide_length,
              pkTitle: resData.entity_name,
              pkFriendlyUrl: resData.friendly_url,
              pkDescription: resData['description'],
              //pkDescription: '',
              PKCreationPresentationId: resData.entity_uuid,
              pkAudio:resData.audio_url,
              pkAudioOrig:resData.audio_url,
              audioFileName,
              audio_delay:resData.audio_delay,
              language_abbreviation:resData.language_abbreviation,
              //pad_color:resData.pad_color,
              cover_image_url:resData.image_url,
              slidesChanged: true,
              savedImages:tempUserSlidesArr,
              slide_cover_index:tmp_slide_cover_index,
              slides_array: userUploadedSlidesRes.data || []
            });    
            
        } catch (err) {
            console.error("Error in PresentationAudio",err);
        }
        //slideCoverArr = LegacyJSON.slideCoverImage['PkCoverImg'];
        
    }

    componentDidMount = async function () {
        window.scrollTo(0, 0);
        //let receivedProps = this.props.received_props;let padCol;
        
        await this.APICalls();
        
        /*
        try {
            let [presentationRes,userUploadedSlidesRes] = await Promise.all([
                axios.get(`${presentation_Creation_API}/${this.props.presentation_uuid}`, myHeaders_Auth_With_Cache_Control),
                axios.get(`${presentation_Creation_API}/${this.props.presentation_uuid}/slides?sort_obj=${encodeURIComponent('{"order_integer":"asc"}')}`, myHeaders_Auth_With_Cache_Control),
            ]);

            let storedCatTempArr=[];
            let tmp_presentation_cats_obj = {};
            let cover_image_url = "";
            if (presentationRes.data) {
                let resData = presentationRes.data;
                // get simple audio file name
                let audioFileName = "";
                if (resData.audio_url) {
                    let tmp_array = resData.audio_url.split('/');
                    audioFileName = tmp_array[tmp_array.length-1];
                }

                let slide_count = this.default_slide_count;
                let slide_length = this.default_slide_length;
                if (resData.slide_count) {
                    slide_count = resData.slide_count;
                }
                if (resData.slide_length) {
                    slide_length = resData.slide_length;
                }
                let wrapup_time_ms = 0;
                if (resData.wrapup_time_ms) {
                    wrapup_time_ms = resData.wrapup_time_ms;
                }

                this.setState({
                    presentation_info: presentationRes.data,
                    
                    
                    wrapup_time_ms,
                    slide_count,
                    slide_length,
                    pkTitle: resData.entity_name,
                    pkFriendlyUrl: resData.friendly_url,
                    pkDescription: resData['description'],
                    //pkDescription: '',
                    PKCreationPresentationId: resData.entity_uuid,
                    pkAudio:resData.audio_url,
                    pkAudioOrig:resData.audio_url,
                    audioFileName,
                    audio_delay:resData.audio_delay,
                    language_abbreviation:resData.language_abbreviation,
                    //pad_color:resData.pad_color,
                    cover_image_url:resData.image_url,
                    slidesChanged: true
                })
                let padCol=resData.pad_color;
                //console.log("API resData",resData);
                //console.log("API padCol",padCol);
                if (padCol) {
                    this.setState({ pad_color: padCol });
                }
                cover_image_url = presentationRes.data.image_url;
            }
            if (userUploadedSlidesRes.data) {
                let tempUserSlidesArr=[];
                let tmp_slide_cover_index = 0;
                userUploadedSlidesRes.data.forEach((item)=>{
                    tempUserSlidesArr.push({
                        source: item.image_url,
                        name: item.entity_name,
                        xref_data:item.xref_data.order_integer,
                        entity_uuid:item.entity_uuid
                    });
                    
                    if (cover_image_url && cover_image_url === item.image_url) {
                        tmp_slide_cover_index = item.xref_data.order_integer - 1;
                    }
                });
                this.setState({
                    savedImages:tempUserSlidesArr,
                    slide_cover_index:tmp_slide_cover_index,
                    slides_array: userUploadedSlidesRes.data || []
                });
            }
            this.setState({ loading: false });    
            
        } catch (err) {
            console.error("Error in PresentationAudio",err);
        }
        */
        //slideCoverArr = LegacyJSON.slideCoverImage['PkCoverImg'];
    }

    next = () => {
      if (user_Status_Ver === "1") {
        saveKey('PKListMessage',JSON.stringify({messages:['Your Edited PK is currently processing','The updated version should be available in less than 5 minutes']}));
      } else {
        saveKey('PKListMessage',JSON.stringify({messages:['Please verify your email address before publishing your PK']}));
      }
      //this.props.history.push(`${this.workspace_base_url}${local_routes.pklist}`);  
      let next_page = `${this.workspace_base_url}${local_routes.pklist}`;
      if (this.props.source_info && this.props.source_info.referrer) {
          next_page = this.props.source_info.referrer;
      }
      this.props.history.push(next_page);
    }

    prev = () => {
        //const { match: { params: { event_uuid } = {} } = {} } = this.props;
        this.props.history.push(`${this.workspace_base_url}${local_routes.pkcreation}/${this.props.presentation_uuid}/slides`);
        //this.props.prev();
    }

    handleOnChange(e) {
        this.setState({ [e.target.id]: e.target.value })
    }
    handleOnCheck(e) {
        this.setState({ [e.target.id]: !this.state.terms })
    }
    
    backToSelectAudio = async () => {
        this.setState({ audioType: "", loading: true });
        await this.APICalls();
    }

    handleCancel = async () => {
        let next_page = `${this.workspace_base_url}${local_routes.pklist}`;
        if (this.props.source_info && this.props.source_info.referrer) {
            next_page = this.props.source_info.referrer;
        }
        this.props.history.push(next_page);
    }

    render() {
        // this.state.images.map((image) => {
        //     arrimage.push(image);
        // })
        const { allowed,descriptionLoader,ImgPublishBtn,ImageUploadLoader, pkTitleCollision, imageValidator, savedImages } = this.state;
        
        //console.log("RENDER",this.state.audioType);

        if (!user_access_token) {
            return (
                <EmptyMessage empty_message="Please Login/Register to create a PK" />
            )
        }
        if (!allowed) {
            return (
                <EmptyMessage empty_message="Not allowed to edit this PK" />
            )
        }
        if (this.state.loading === true) {
            return (
                <ActivityIndicator theme="spinner" />
            )
        }
        if (user_Status !== 1) {
            return (
                <EmptyMessage empty_message="Please complete your verification to create a PK" />
            )
        }

        if (this.state.audioType === 'record' || this.state.audioType === 'upload') {
            return <div>
                <PresentationSingleRecording
                    onChange={this.handleOnChange.bind(this)}
                    onCheck={this.handleOnCheck.bind(this)}
                    //SlideImageArr={slideImgPresentation}
                    //SlideImageArr={this.state.images}
                    SlideImageArr={this.state.savedImages}
                    pad_color={this.state.pad_color}
                    audioType={this.state.audioType}
                    next={this.next.bind(this)}
                    prev={this.prev.bind(this)}
                    PKCreationPresentationId={this.state.PKCreationPresentationId}
                    PKCreationPresentationName={this.state.pkFriendlyUrl} 
                    pkAudio={this.state.pkAudio}
                    receivedProps={this.props.presentation_uuid}
                    clickArea="startRecording"
                    audio_delay={this.state.audio_delay}
                    language_abbreviation={this.state.language_abbreviation}
                    slidesChanged={this.state.slidesChanged}
                    //slide_cover_index={this.state.slide_cover_index}
                    cover_image_url={this.state.cover_image_url}
                    backToSelectAudio={this.backToSelectAudio.bind(this)}
                    slide_count={this.state.slide_count}
                    slide_length={this.state.slide_length}
                    wrapup_time_ms={this.state.wrapup_time_ms}
                    silent_flag={this.state.silent_flag}
                    //silence_file={this.state.silence_file}
                />
            </div>
        } else if (this.state.audioType === 'record_per_slide') {
            return <div>
                <PresentationRecordingPerSlide
                    next={this.next.bind(this)}
                    prev={this.prev.bind(this)}
                    backToSelectAudio={this.backToSelectAudio.bind(this)}
                    slidesChanged={this.state.slidesChanged}
                    audioType={this.state.audioType}

                    slides_array={this.state.slides_array}
                    presentation_info={this.state.presentation_info}

                    /*                    
                    onChange={this.handleOnChange.bind(this)}
                    onCheck={this.handleOnCheck.bind(this)}
                    SlideImageArr={this.state.savedImages}
                    pad_color={this.state.pad_color}
                    audioType={this.state.audioType}
                    next={this.next.bind(this)}
                    prev={this.prev.bind(this)}
                    PKCreationPresentationId={this.state.PKCreationPresentationId}
                    PKCreationPresentationName={this.state.pkFriendlyUrl} 
                    pkAudio={this.state.pkAudio}
                    receivedProps={this.props.presentation_uuid}
                    clickArea="startRecording"
                    audio_delay={this.state.audio_delay}
                    language_abbreviation={this.state.language_abbreviation}
                    slidesChanged={this.state.slidesChanged}
                    slide_cover_index={this.state.slide_cover_index}
                    backToSelectAudio={this.backToSelectAudio.bind(this)}
                    slide_count={this.state.slide_count}
                    slide_length={this.state.slide_length}
                    wrapup_time_ms={this.state.wrapup_time_ms}
                    silent_flag={this.state.silent_flag}
                    //silence_file={this.state.silence_file}
                    */
                />
            </div>
        } else if (this.state.audioType === 'record_video_per_slide') {
            return <div>
                <PresentationVideoSingleRecording

                    next={this.next.bind(this)}
                    prev={this.prev.bind(this)}
                    backToSelectAudio={this.backToSelectAudio.bind(this)}
                    slidesChanged={this.state.slidesChanged}
                    audioType={this.state.audioType}

                    slides_array={this.state.slides_array}
                    presentation_info={this.state.presentation_info}
                />
            </div>
        } else if (this.state.audioType === 'record_video' || this.state.audioType === 'upload_video') {
            return <div>
                <PresentationVideoSingleRecording

                    next={this.next.bind(this)}
                    prev={this.prev.bind(this)}
                    backToSelectAudio={this.backToSelectAudio.bind(this)}
                    slidesChanged={this.state.slidesChanged}
                    audioType={this.state.audioType}

                    slides_array={this.state.slides_array}
                    presentation_info={this.state.presentation_info}
                />
            </div>      
        } else {
            return (
                <div>
    
                    <div className="form-card">
                        <Row className="Record-section">
                            <Col lg={12}>
                                <h6 className="audio-head pad20">
                                    Please Select an option for adding audio to your
                                    PK</h6>
                            </Col>
                            <Col lg={6} md={6} className="pad0">
                                <div className="pad-r13">
                                    <div className="record-audio m-bot100" style={{ paddingTop: "5px", paddingBottom: "5px" }} >
                                        <div className="img-align">
                                            <img
                                                src={mic}
                                                alt="mic"
                                                className="img-fluid"
                                            />
                                        </div>
                                        <h6 className="audio-head">Record Audio</h6>
                                        {this.usingMediaRecorder ? 
                                        <React.Fragment>
                                        <p>Use your device to record audio / video over your
                                            slides</p>

                                        { this.state.slide_count > 1 &&
                                            <div className="padtop30">
                                                <Button
                                                  //theme="recording-btn"
                                                  //OnClickMet={() => this.startRecording('record_per_slide')}
                                                  variant="pkprimary"
                                                  onClick={() => this.startRecording('record_per_slide')}
                                                  //data-tip={isIOS ? "iOS audio recording will work best in Safari, and by enabling your browser's MediaRecorder: 1. Go to Settings → Safari → Advanced → Experimental Features; 2. Enable MediaRecorder" : ''}
                                                >
                                                  Start Recording Audio - Per Slide
                                                </Button>
                                            </div>
                                        }
                                        <div className="padtop30">
                                            <Button
                                              //theme="recording-btn"
                                              //OnClickMet={() => this.startRecording('record')}
                                              variant="pkprimary"
                                              onClick={() => this.startRecording('record')}
                                              //data-tip={isIOS ? "iOS audio recording will work best in Safari, and by enabling your browser's MediaRecorder: 1. Go to Settings → Safari → Advanced → Experimental Features; 2. Enable MediaRecorder" : ''}
                                            >
                                              Start Recording Audio - Entire Presentation
                                            </Button>
                                        </div>
                                        { (this.workspace_base_url || user_account_level === 'private' || user_access_level.endsWith('admin')) ?
                                          <React.Fragment>
                                            { this.state.slide_count > 1 &&
                                              <div className="padtop30">
                                                  <Button
                                                    //theme="recording-btn"
                                                    //OnClickMet={() => this.startRecording('record_video')}
                                                    variant="pkprimary"
                                                    onClick={() => this.startRecording('record_video_per_slide')}
                                                    //data-tip={isIOS ? "iOS video recording requires Safari, plus enabling your browser's MediaRecorder: 1. Go to Settings → Safari → Advanced → Experimental Features; 2. Enable MediaRecorder" : ''}
                                                  >
                                                      Start Recording Video - Per Slide {isIOS ? <i className="fa fa-asterisk" aria-hidden="true"></i> : ''}
                                                  </Button>
                                              </div>
                                            }
                                              
                                              <div className="padtop30">
                                                  <Button
                                                    //theme="recording-btn"
                                                    //OnClickMet={() => this.startRecording('record_video')}
                                                    variant="pkprimary"
                                                    onClick={() => this.startRecording('record_video')}
                                                    //data-tip={isIOS ? "iOS video recording requires Safari, plus enabling your browser's MediaRecorder: 1. Go to Settings → Safari → Advanced → Experimental Features; 2. Enable MediaRecorder" : ''}
                                                  >
                                                      Start Recording Video - Entire Presentation {isIOS ? <i className="fa fa-asterisk" aria-hidden="true"></i> : ''}
                                                  </Button>
                                                  
                                              </div>
                                          </React.Fragment>
                                          :
                                          <React.Fragment>
                                              {/*
                                              <div className="padtop30">
                                                  <Button theme="recording-btn" OnClickMet={() => this.startRecording('record_video_per_slide')}>
                                                      Start Recording Video - Per Slide</Button>
                                              </div>
                                              */}
                                             { this.state.slide_count > 1 &&
                                             <div className="padtop30">
                                                <Link to={local_routes.pricing}>
                                                  <Button
                                                    //theme="recording-btn"
                                                    //OnClickMet={() => this.startRecording('record_video')}
                                                    variant="pkprimary"
                                                    //onClick={() => this.startRecording('record_video')}
                                                    //data-tip={isIOS ? "*Requires PK Create PRO*; iOS video recording requires Safari, plus enabling your browser's MediaRecorder: 1. Go to Settings → Safari → Advanced → Experimental Features; Enable 2. MediaRecorder" : '*Requires PK Create PRO*'}
                                                  >
                                                      Start Recording Video - Per Slide <i className="fa fa-level-up" aria-hidden="true"></i> {isIOS ? <i className="fa fa-asterisk" aria-hidden="true"></i> : ''}
                                                  </Button>
                                                </Link>    
                                              </div>
                                             }
                                              <div className="padtop30">
                                                <Link to={local_routes.pricing}>
                                                  <Button
                                                    //theme="recording-btn"
                                                    //OnClickMet={() => this.startRecording('record_video')}
                                                    variant="pkprimary"
                                                    //onClick={() => this.startRecording('record_video')}
                                                    //data-tip={isIOS ? "*Requires PK Create PRO*; iOS video recording requires Safari, plus enabling your browser's MediaRecorder: 1. Go to Settings → Safari → Advanced → Experimental Features; Enable 2. MediaRecorder" : '*Requires PK Create PRO*'}
                                                  >
                                                      Start Recording Video - Entire Presentation <i className="fa fa-level-up" aria-hidden="true"></i> {isIOS ? <i className="fa fa-asterisk" aria-hidden="true"></i> : ''}
                                                  </Button>
                                                </Link>    
                                              </div>
                                              
                                          </React.Fragment>                                         
                                        }
                                        </React.Fragment>
                                        :
                                        <React.Fragment>
                                        <p>Sorry! Your browser/OS is currently unsupported for recording audio.
                                        Please try Chrome on desktop for best results
                                        </p>
                                        <div className="padtop30">
                                        </div>
                                        </React.Fragment>
                                        }
                                    </div>
                                </div>
                            </Col>
                            <Col lg={6} md={6} className="pad0">
                                <div className="pad-l15">
                                    <div className="record-audio" style={{ paddingTop: "5px", paddingBottom: "5px" }}>
                                        <div className="img-align">
                                            <img
                                                src={cloud}
                                                alt="mic"
                                                className="img-fluid"
                                            />
                                        </div>
                                        <h6 className="audio-head">Keep Audio / Upload New Audio</h6>
                                        <p>Keep current audio / video, or upload a new audio / video file</p>
                                        <div className="padtop30 upload-audio">
                                            <Button
                                              //theme="recording-btn"
                                              //OnClickMet={this.uploadRecording}
                                              variant="pkprimary"
                                              onClick={this.uploadRecording}
                                            >
                                              Keep Audio / Upload Your Audio
                                            </Button>
                                        </div>
                                        { (this.workspace_base_url || user_account_level === 'private' || user_access_level.endsWith('admin')) ?
                                          <div className="padtop30 upload-audio">
                                              <Button
                                                //theme="recording-btn"
                                                //OnClickMet={() => this.startRecording('upload_video')}
                                                variant="pkprimary"
                                                onClick={() => this.startRecording('upload_video')}
                                              >
                                                Keep Video / Upload Your Video
                                              </Button>
                                          </div>
                                          :
                                          <div className="padtop30 upload-audio">
                                              <Link to={local_routes.pricing}>
                                                <Button
                                                  variant="pkprimary"
                                                  data-tip="*Requires PK Create PRO*"
                                                  //onClick={() => this.startRecording('upload_video')}
                                                >
                                                  Keep Video / Upload Your Video <i className="fa fa-level-up" aria-hidden="true"></i>
                                                </Button>
                                              </Link>
                                          </div>
                                        }
                                        
                                        <div className="padtop30 upload-audio">
                                            <Button
                                              //theme="recording-btn"
                                              //OnClickMet={this.uploadSilence}
                                              variant="pkprimary"
                                              onClick={this.uploadSilence}
                                            >
                                              Silent (No Audio)
                                            </Button>
                                        </div>
                                        
                                    </div>
                                </div>
                            </Col>

                            <div className="img-align img-position">
                                
                                <img
                                    src={this.context.theme === "dark" ? dark_option : option}
                                    alt="option"
                                    className="img-fluid desk-block"
                                />
                                
                                {/*
                                <img
                                    src={option1}
                                    alt="option"
                                    className="img-fluid m-block"
                                />
                                */}
                            </div>
                            
                        </Row>
                        {/*
                        { isIOS &&
                        <Row>
                          <Col xs={12} className="flex justify-content-center">
                            <span style={{ fontSize: "smaller"}}><i className="fa fa-asterisk" aria-hidden="true"></i> iOS video recording requires Safari, plus enabling your browser's MediaRecorder: 1. Go to Settings → Safari → Advanced → Experimental Features; 2. Enable MediaRecorder</span>
                          </Col>
                        </Row>
                        }
                        */}
                        { (!this.workspace_base_url && user_account_level !== 'private' && !user_access_level.endsWith('admin')) &&
                        <Row>
                          <Col xs={12} className="flex justify-content-center">
                            <span style={{ fontSize: "smaller"}}><i className="fa fa-level-up" aria-hidden="true"></i> Requires PK Create PRO - Visit our <Link to={local_routes.pricing}>Pricing</Link> page for details</span>
                          </Col>
                        </Row>
                        }
                        
                        <div className="form-group btn-position">
                        {/*<div className="upload-Slides form-group">*/}
                            <button className="btn btn-draft" onClick={this.prev}>Previous</button>
                            <button className="btn btn-draft" onClick={() => this.handleCancel()}>Cancel</button>
                        </div>
                    </div>
                    <ReactTooltip/>
                </div>
            );
        }
    }
}

export default withRouter(PresentationAudio);
